import { useState } from "react";
import { Clock, Inbox } from "lucide-react";

import type { ActionQueue as ActionQueueData } from "@/types/actions";
import { EmptyState } from "@/components/ui/empty-state";
import { Button } from "@/components/ui/button";

import { ActionCard } from "./action-card";

export function ActionQueue({ queue, showRole }: { queue: ActionQueueData; showRole: boolean }) {
	const [view, setView] = useState<"active" | "waiting">("active");
	const actions = { active: queue.actions, waiting: queue.waiting }[view];
	const viewLabels = {
		active: {
			activeVariant: "default",
			waitingVariant: "outline",
			empty: "nenhuma pendência para agora",
		},
		waiting: {
			activeVariant: "outline",
			waitingVariant: "default",
			empty: "nenhuma pendência aguardando",
		},
	} as const;

	return (
		<div data-component="action-queue" className="flex flex-col">
			<div
				role="group"
				aria-label="pendências"
				className="flex flex-wrap gap-2 border-b border-border p-4"
			>
				<Button
					type="button"
					size="sm"
					variant={viewLabels[view].activeVariant}
					aria-pressed={view === "active"}
					onClick={() => setView("active")}
				>
					agora <span className="font-mono text-xs">{queue.actions.length}</span>
				</Button>
				<Button
					type="button"
					data-slot="waiting-view"
					size="sm"
					variant={viewLabels[view].waitingVariant}
					aria-pressed={view === "waiting"}
					onClick={() => setView("waiting")}
				>
					<Clock /> aguardando <span className="font-mono text-xs">{queue.waiting.length}</span>
				</Button>
			</div>
			{actions.length === 0 && (
				<div className="bg-card">
					<EmptyState icon={Inbox} title={viewLabels[view].empty} />
				</div>
			)}

			{actions.map((action) => (
				<ActionCard key={action.id} action={action} showRole={showRole} />
			))}
		</div>
	);
}
